var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVoiceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.14883 3.62959C9.14883 2.39884 8.18675 1.40112 6.99995 1.40112C5.81316 1.40112 4.85107 2.39884 4.85107 3.62959V7.76817C4.85107 8.99892 5.81316 9.99664 6.99995 9.99664C8.18675 9.99664 9.14883 8.99892 9.14883 7.76817V3.62959Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.14883 3.62959C9.14883 2.39884 8.18675 1.40112 6.99995 1.40112C5.81316 1.40112 4.85107 2.39884 4.85107 3.62959V7.76817C4.85107 8.99892 5.81316 9.99664 6.99995 9.99664C8.18675 9.99664 9.14883 8.99892 9.14883 7.76817V3.62959Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.62769 7.07776C1.62769 10.0446 4.033 12.45 6.99988 12.45M6.99988 12.45C9.96677 12.45 12.3721 10.0446 12.3721 7.07776M6.99988 12.45V14.5988",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.62769 7.07776C1.62769 10.0446 4.033 12.45 6.99988 12.45M6.99988 12.45C9.96677 12.45 12.3721 10.0446 12.3721 7.07776M6.99988 12.45V14.5988",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoiceIcon);
export default __webpack_public_path__ + "static/media/voice-icon.81cfa739514432c22da0ab707b476c0e.svg";
export { ForwardRef as ReactComponent };